const RCMServices = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 via-blue-50 to-white">
      
      {/* Hero Section */}
      <section className="pt-36 pb-16 lg:pt-40 lg:pb-24">
        <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            
            {/* Left Content */}
            <div>
              <h1 className="text-4xl lg:text-5xl font-bold text-blue-500 mb-6 leading-tight">
                Revenue Cycle Management {' '}
                <span className="text-gray-900">Services for Healthcare Practices</span>
              </h1>
              
              <p className="text-lg text-gray-700 leading-relaxed mb-8">
                Healthcare practices can improve their financial performance with more precision and control due to our exceptional revenue cycle management services. We guarantee a more consistent and smooth cash flow by reducing claim denials and accelerating reimbursements.
              </p>

              <button className="bg-blue-800 hover:bg-blue-700 text-white font-bold px-8 py-4 rounded-lg transition-colors shadow-lg">
                Contact Us
              </button>
            </div>

            {/* Right Image */}
            <div className="flex justify-center lg:justify-end">
              <img 
                src="/billing7.webp" 
                alt="Revenue Cycle Management" 
                className="w-full max-w-lg"
              />
            </div>

          </div>
        </div>
      </section>

      {/* RCM Details Section */}
      <section className="py-10 lg:py-13 bg-white">
        <div className="max-w-[1250px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            
            {/* Left Image - 50% */}
            <div className="flex justify-center lg:justify-start">
              <img 
                src="/billing6.jpg" 
                alt="Revenue Cycle Management Process" 
                className="w-full rounded-2xl shadow-xl"
              />
            </div>

            {/* Right Content - 50% */}
            <div>
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4 leading-tight">
                Revenue Cycle Management{' '}
                <span className="text-blue-500">For Maximum Reimbursement</span>
              </h2>
              
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                Revenue cycle management is the complete process of tracking patients from registration to final payment, used by healthcare providers to get paid by patients through insurance. It includes all the steps, from booking an appointment by the patient to getting the full payment by the provider. At iSolve RCM, our RCM in medical billing helps you to maximize reimbursement and receive full payment without any delay. Our medical billing RCM experts know everything to make the revenue cycle management process smooth and easy for you.
              </p>

              <button className="bg-blue-800 hover:bg-blue-700 text-white font-bold px-8 py-4 rounded-lg transition-colors shadow-lg">
                contact us
              </button>
            </div>

          </div>
        </div>
      </section>

      {/* HIPAA-Compliant Services Section */}
      <section className="py-10 lg:py-12 bg-gray-50">
        <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8 text-center">
          
          <h2 className="text-3xl lg:text-4xl font-bold mb-6 leading-tight">
            <span className="text-blue-500">Our HIPAA-Compliant</span>{' '}
            <span className="text-gray-900">Revenue Cycle Management</span>{' '}
            <span className="text-blue-500">Services</span>
          </h2>
          
          <p className="text-base text-gray-700 leading-relaxed max-w-5xl mx-auto">
            Are you looking for a HIPAA-compliant medical billing company to get the best revenue cycle management solutions? iSolve RCM, a leading revenue cycle management company, has got it handled. We have a team of revenue cycle specialists who possess a deep understanding of RCM coding and the RCM cycle in medical billing. They go above and beyond to provide expert revenue cycle management services, which help you save maximum revenue. Below is a list of RCM services we provide:
          </p>

        </div>
      </section>

      {/* Medical Billing Services Section */}
      <section className="py-10 lg:py-12">
        <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
          
          <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-3xl p-8 lg:p-12 shadow-lg">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              
              {/* Left Content */}
              <div>
                <h2 className="text-3xl lg:text-4xl font-bold mb-6 leading-tight">
                  <span className="text-blue-500">Medical</span>{' '}
                  <span className="text-gray-900">Billing Services</span>
                </h2>
                
                <p className="text-base text-gray-700 leading-relaxed mb-6">
                  Medical billing is one of the key attributes of any medical practice, whether it is run by a healthcare clinic or a hospital. Without it, you cannot boost revenue and maximize reimbursement. Our expert medical billers know all the reimbursement strategies, which not only allow you to treat your patients carefully but also improve cash flow. Our fee for medical billing services is as low as 2.99% of monthly collections.
                </p>

                <button className="bg-blue-800 hover:bg-blue-700 text-white font-bold px-8 py-4 rounded-lg transition-colors shadow-lg">
                  Read More
                </button>
              </div>

              {/* Right Image */}
              <div className="flex justify-center lg:justify-end">
                <img 
                  src="/billing1.avif" 
                  alt="Medical Billing Services" 
                  className="w-full max-w-md rounded-2xl shadow-xl"
                />
              </div>

            </div>
          </div>

        </div>
      </section>

      {/* Medical Coding Services Section */}
      <section className="py-4 lg:py-4">
        <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
          
          <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-3xl p-8 lg:p-12 shadow-lg">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              
              {/* Left Image */}
              <div className="flex justify-center lg:justify-start">
                <img 
                  src="/billing9.jpg" 
                  alt="Medical Coding Services" 
                  className="w-full max-w-md rounded-2xl shadow-xl"
                />
              </div>

              {/* Right Content */}
              <div>
                <h2 className="text-3xl lg:text-4xl font-bold mb-6 leading-tight">
                  <span className="text-blue-500">Medical</span>{' '}
                  <span className="text-gray-900">Coding Services</span>
                </h2>
                
                <p className="text-base text-gray-700 leading-relaxed mb-6">
                  You cannot get paid without professional medical coding services. At iSolve RCM, we have certified coders who thoroughly examine the patient records issued by a doctor. They then translate them into standardized codes with the help of Optum360 EncoderPro, TruCode Encoder, and more. After assigning the right codes, we enter them into medical billing software to form insurance claims, which helps reduce claim denials.
                </p>

                <button className="bg-blue-800 hover:bg-blue-700 text-white font-bold px-8 py-4 rounded-lg transition-colors shadow-lg">
                  Read More
                </button>
              </div>

            </div>
          </div>

        </div>
      </section>

      {/* Medical Billing Audit Section */}
      <section className="py-10 lg:py-12">
        <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
          
          <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-3xl p-8 lg:p-12 shadow-lg">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              
              {/* Left Content */}
              <div>
                <h2 className="text-3xl lg:text-4xl font-bold mb-6 leading-tight">
                  <span className="text-blue-500">Medical</span>{' '}
                  <span className="text-gray-900">Billing Audit</span>
                </h2>
                
                <p className="text-base text-gray-700 leading-relaxed mb-6">
                  There is always room for improvement in anything, and knowing your errors helps you improve, and that's what medical billing auditors do. They detect errors in your medical billing and correct them to ensure accuracy. This also helps you boost revenue by saving billions of dollars. Count on us for the best and most skilled medical billing audit services.
                </p>

                <button className="bg-blue-800 hover:bg-blue-700 text-white font-bold px-8 py-4 rounded-lg transition-colors shadow-lg">
                  Read More
                </button>
              </div>

              {/* Right Image */}
              <div className="flex justify-center lg:justify-end">
                <img 
                  src="/billing11.jpeg" 
                  alt="Medical Billing Audit" 
                  className="w-full max-w-md rounded-2xl shadow-xl"
                />
              </div>

            </div>
          </div>

        </div>
      </section>

      {/* Denial Management Services Section */}
      <section className="py-6 lg:py-6">
        <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
          
          <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-3xl p-8 lg:p-12 shadow-lg">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              
              {/* Left Image */}
              <div className="flex justify-center lg:justify-start">
                <img 
                  src="/billing10.jpg" 
                  alt="Denial Management Services" 
                  className="w-full max-w-md rounded-2xl shadow-xl"
                />
              </div>

              {/* Right Content */}
              <div>
                <h2 className="text-3xl lg:text-4xl font-bold mb-6 leading-tight">
                  <span className="text-blue-500">Denial</span>{' '}
                  <span className="text-gray-900">Management Services</span>
                </h2>
                
                <p className="text-base text-gray-700 leading-relaxed mb-6">
                  When a health insurance provider refuses to approve a claim due to incomplete coding, missing information, or any other issue, it should be corrected quickly to prevent claim rejections. We have a professional team that quickly identifies the error, then fixes it and protects revenue by avoiding claim denials. Contact us for effective denial management services.
                </p>

                <button className="bg-blue-800 hover:bg-blue-700 text-white font-bold px-8 py-4 rounded-lg transition-colors shadow-lg">
                  Read More
                </button>
              </div>

            </div>
          </div>

        </div>
      </section>

      {/* Accounts Receivable Management Section */}
      <section className="py-10 lg:py-10">
        <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
          
          <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-3xl p-8 lg:p-12 shadow-lg">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              
              {/* Left Content */}
              <div>
                <h2 className="text-3xl lg:text-4xl font-bold mb-6 leading-tight">
                  <span className="text-blue-500">Accounts</span>{' '}
                  <span className="text-gray-900">Receivable Management</span>
                </h2>
                
                <p className="text-base text-gray-700 leading-relaxed mb-6">
                  Accurate accounts receivable management is necessary for preventing overdue payments. It helps healthcare providers maintain a steady cash flow by recovering delayed payments. Our certified medical billing experts use the latest technology and proven strategies to recover unpaid claims. Rely on us for the best accounts receivable management services.
                </p>

                <button className="bg-blue-800 hover:bg-blue-700 text-white font-bold px-8 py-4 rounded-lg transition-colors shadow-lg">
                  Read More
                </button>
              </div>

              {/* Right Image */}
              <div className="flex justify-center lg:justify-end">
                <img 
                  src="/billing6.jpg" 
                  alt="Accounts Receivable Management" 
                  className="w-full max-w-md rounded-2xl shadow-xl"
                />
              </div>

            </div>
          </div>

        </div>
      </section>

      {/* Medical Credentialing Services Section */}
      <section className="py-8 lg:py-8">
        <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
          
          <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-3xl p-8 lg:p-12 shadow-lg">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              
              {/* Left Image */}
              <div className="flex justify-center lg:justify-start">
                <img 
                  src="/billing11.jpeg" 
                  alt="Medical Credentialing Services" 
                  className="w-full max-w-md rounded-2xl shadow-xl"
                />
              </div>

              {/* Right Content */}
              <div>
                <h2 className="text-3xl lg:text-4xl font-bold mb-6 leading-tight">
                  <span className="text-blue-500">Medical</span>{' '}
                  <span className="text-gray-900">Credentialing Services</span>
                </h2>
                
                <p className="text-base text-gray-700 leading-relaxed mb-6">
                  The medical credentialing process is complex and time-consuming. Our credentialing specialists pay full attention to verifying all documents with care and precision. They also maintain strong communication with healthcare providers, ensuring the financial success of healthcare providers. Trust us for quick medical credentialing services.
                </p>

                <button className="bg-blue-800 hover:bg-blue-700 text-white font-bold px-8 py-4 rounded-lg transition-colors shadow-lg">
                  Read More
                </button>
              </div>

            </div>
          </div>

        </div>
      </section>

      {/* Steps of RCM Section */}
      <section className="py-10 lg:py-10 bg-white">
        <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Section Title */}
          <h2 className="text-3xl lg:text-4xl font-bold text-center mb-6 leading-tight">
            <span className="text-blue-500">Steps Of</span>{' '}
            <span className="text-gray-900">Revenue Cycle Management</span>{' '}
            <span className="text-blue-500">In Medical Billing</span>
          </h2>
          
          <p className="text-base text-gray-700 leading-relaxed text-center max-w-5xl mx-auto mb-12">
            Optimized revenue cycle management plays a crucial role in forming a successful healthcare practice. It makes sure that the healthcare providers get their payments on time for the medical treatment performed by them. It is a complete cycle of financial steps that starts with patient registration and ends with payment posting. You can lessen the number of denied claims, maximize collections, and stay aligned with legal standards. Below are some of the critical steps in our medical revenue cycle management services
          </p>

          {/* Steps Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            
            {/* Step 1 */}
            <div className="bg-white rounded-2xl p-8 text-center shadow-md hover:shadow-xl transition-all">
              <div className="flex justify-center mb-4">
                <svg className="w-20 h-20 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/>
                </svg>
              </div>
              <h3 className="text-lg font-bold text-blue-600">Patient pre-authorization</h3>
            </div>

            {/* Step 2 */}
            <div className="bg-white rounded-2xl p-8 text-center shadow-md hover:shadow-xl transition-all">
              <div className="flex justify-center mb-4">
                <svg className="w-20 h-20 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
                </svg>
              </div>
              <h3 className="text-lg font-bold text-blue-600">Eligibility verification</h3>
            </div>

            {/* Step 3 */}
            <div className="bg-white rounded-2xl p-8 text-center shadow-md hover:shadow-xl transition-all">
              <div className="flex justify-center mb-4">
                <svg className="w-20 h-20 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20 3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h3l-1 1v2h12v-2l-1-1h3c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H4V5h16v11z"/>
                  <path d="M6 8.25h8v1.5H6zm0 3h8v1.5H6zm10-3h2v1.5h-2zm0 3h2v1.5h-2z"/>
                </svg>
              </div>
              <h3 className="text-lg font-bold text-blue-600">Medical coding</h3>
            </div>

            {/* Step 4 */}
            <div className="bg-white rounded-2xl p-8 text-center shadow-md hover:shadow-xl transition-all">
              <div className="flex justify-center mb-4">
                <svg className="w-20 h-20 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"/>
                </svg>
              </div>
              <h3 className="text-lg font-bold text-blue-600">Charge entry</h3>
            </div>

            {/* Step 5 */}
            <div className="bg-white rounded-2xl p-8 text-center shadow-md hover:shadow-xl transition-all">
              <div className="flex justify-center mb-4">
                <svg className="w-20 h-20 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
                </svg>
              </div>
              <h3 className="text-lg font-bold text-blue-600">Claims creation</h3>
            </div>

            {/* Step 6 */}
            <div className="bg-white rounded-2xl p-8 text-center shadow-md hover:shadow-xl transition-all">
              <div className="flex justify-center mb-4">
                <svg className="w-20 h-20 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
                </svg>
              </div>
              <h3 className="text-lg font-bold text-blue-600">Payment posting</h3>
            </div>

            {/* Step 7 */}
            <div className="bg-white rounded-2xl p-8 text-center shadow-md hover:shadow-xl transition-all">
              <div className="flex justify-center mb-4">
                <svg className="w-20 h-20 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                </svg>
              </div>
              <h3 className="text-lg font-bold text-blue-600">Denial management</h3>
            </div>

            {/* Step 8 */}
            <div className="bg-white rounded-2xl p-8 text-center shadow-md hover:shadow-xl transition-all">
              <div className="flex justify-center mb-4">
                <svg className="w-20 h-20 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"/>
                </svg>
              </div>
              <h3 className="text-lg font-bold text-blue-600">A/R management</h3>
            </div>

            {/* Step 9 */}
            <div className="bg-white rounded-2xl p-8 text-center shadow-md hover:shadow-xl transition-all">
              <div className="flex justify-center mb-4">
                <svg className="w-20 h-20 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm7 13H5v-.23c0-.62.28-1.2.76-1.58C7.47 15.82 9.64 15 12 15s4.53.82 6.24 2.19c.48.38.76.97.76 1.58V19z"/>
                </svg>
              </div>
              <h3 className="text-lg font-bold text-blue-600">Patient billing and collections</h3>
            </div>

            {/* Step 10 */}
            <div className="bg-white rounded-2xl p-8 text-center shadow-md hover:shadow-xl transition-all">
              <div className="flex justify-center mb-4">
                <svg className="w-20 h-20 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/>
                </svg>
              </div>
              <h3 className="text-lg font-bold text-blue-600">Medical billing auditing</h3>
            </div>

            {/* Step 11 */}
            <div className="bg-white rounded-2xl p-8 text-center shadow-md hover:shadow-xl transition-all">
              <div className="flex justify-center mb-4">
                <svg className="w-20 h-20 text-blue-500" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
                  <path d="M9 13h6v2H9z"/>
                </svg>
              </div>
              <h3 className="text-lg font-bold text-blue-500">Monthly reporting</h3>
            </div>

            {/* Step 12 */}
            <div className="bg-white rounded-2xl p-8 text-center shadow-md hover:shadow-xl transition-all">
              <div className="flex justify-center mb-4">
                <svg className="w-20 h-20 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
                </svg>
              </div>
              <h3 className="text-lg font-bold text-blue-600">Regulatory Compliance</h3>
            </div>

          </div>

        </div>
      </section>

      {/* Why Choose Us & Get Free Consultation Section */}
      <section className="py-12 lg:py-16 bg-gradient-to-br from-blue-50 to-white">
        <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-start">
            
            {/* Left - Why Choose Us - 40% (2 columns) */}
            <div className="lg:col-span-2">
              <h2 className="text-3xl lg:text-4xl font-bold mb-6 leading-tight">
                <span className="text-blue-500">Why</span>{' '}
                <span className="text-gray-900">Choose Us?</span>
              </h2>
              
              <p className="text-base text-gray-700 leading-relaxed mb-8">
                Choose iSolve RCM, one of the top medical billing companies, for affordable medical billing and consulting services that reduce denials and increase collections.
              </p>

              <div className="space-y-4">
                <div className="flex items-start">
                  <svg className="w-6 h-6 text-blue-600 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">100% HIPAA-Compliant Medical Billing</span>
                </div>

                <div className="flex items-start">
                  <svg className="w-6 h-6 text-blue-600 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Boost Revenue</span>
                </div>

                <div className="flex items-start">
                  <svg className="w-6 h-6 text-blue-600 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Less than 1% Rejection</span>
                </div>

                <div className="flex items-start">
                  <svg className="w-6 h-6 text-blue-600 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">99% Acceptance</span>
                </div>

                <div className="flex items-start">
                  <svg className="w-6 h-6 text-blue-600 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">No Hidden Fees</span>
                </div>

                <div className="flex items-start">
                  <svg className="w-6 h-6 text-blue-600 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Enhance reimbursement outcomes</span>
                </div>

                <div className="flex items-start">
                  <svg className="w-6 h-6 text-blue-600 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">24/7 Access</span>
                </div>

                <div className="flex items-start">
                  <svg className="w-6 h-6 text-blue-600 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">As low as 2.99% of monthly collections</span>
                </div>
              </div>
            </div>

            {/* Right - Get Free Consultation Form - 60% (3 columns) */}
            <div className="lg:col-span-3 bg-white rounded-2xl shadow-xl p-8 border border-gray-200">
              <h2 className="text-3xl lg:text-4xl font-bold text-center mb-8 leading-tight">
                <span className="text-blue-500">Get Free</span>{' '}
                <span className="text-gray-900">Consultation</span>
              </h2>

              <form className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <input
                    type="text"
                    placeholder="Full Name"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                  <input
                    type="tel"
                    placeholder="Phone"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <input
                    type="email"
                    placeholder="Email"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                  <input
                    type="text"
                    placeholder="NPI (Optional)"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <input
                    type="text"
                    placeholder="Practice Name"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                  <select className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-500">
                    <option>Alabama</option>
                    <option>Alaska</option>
                    <option>Arizona</option>
                    <option>California</option>
                    <option>Texas</option>
                  </select>
                </div>

                <textarea
                  placeholder="Message"
                  rows="4"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
                ></textarea>

                <button
                  type="submit"
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 px-6 rounded-lg transition-colors shadow-lg"
                >
                  Submit
                </button>
              </form>
            </div>

          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-10 lg:py-12 bg-white">
        <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Section Title */}
          <h2 className="text-3xl lg:text-4xl font-bold mb-6 leading-tight">
            <span className="text-blue-500">Benefits Of Healthcare</span>{' '}
            <span className="text-gray-900">Revenue Cycle Management Services</span>{' '}
            <span className="text-blue-500">With iSolve RCM</span>
          </h2>
          
          <p className="text-base text-gray-700 leading-relaxed mb-12">
            The following are a few of the benefits you get by outsourcing revenue cycle management services with iSolve RCM:
          </p>

          {/* Benefits List */}
          <div className="space-y-4 mb-8">
            <div className="flex items-start">
              <span className="text-blue-600 font-bold mr-3 mt-1">•</span>
              <p className="text-gray-700 leading-relaxed">
                One of the best benefits of healthcare revenue cycle management is that it will not only help you save money but also improve cash flow and prevent claim rejections.
              </p>
            </div>

            <div className="flex items-start">
              <span className="text-blue-600 font-bold mr-3 mt-1">•</span>
              <p className="text-gray-700 leading-relaxed">
                We increase the revenues of healthcare providers through our precise medical billing system.
              </p>
            </div>

            <div className="flex items-start">
              <span className="text-blue-600 font-bold mr-3 mt-1">•</span>
              <p className="text-gray-700 leading-relaxed">
                We optimize your practice's productivity through our expert RCM solutions.
              </p>
            </div>

            <div className="flex items-start">
              <span className="text-blue-600 font-bold mr-3 mt-1">•</span>
              <p className="text-gray-700 leading-relaxed">
                Our RCM experts manage your revenue cycle to minimize administrative responsibilities for you and your staff, so you will have more time for patient care and delivering quality services.
              </p>
            </div>

            <div className="flex items-start">
              <span className="text-blue-600 font-bold mr-3 mt-1">•</span>
              <p className="text-gray-700 leading-relaxed">
                The key benefit of revenue cycle management is that you will get faster reimbursement from an insurance provider when your RCM is managed by the professional team at iSolve RCM.
              </p>
            </div>

            <div className="flex items-start">
              <span className="text-blue-600 font-bold mr-3 mt-1">•</span>
              <p className="text-gray-700 leading-relaxed">
                Our comprehensive revenue billing ensures end-to-end efficiency, which improves the performance of the entire billing process for accurate reimbursement.
              </p>
            </div>
          </div>

          {/* Contact Button */}
          <div>
            <button className="bg-blue-600 hover:bg-blue-700 text-white font-bold px-10 py-4 rounded-lg transition-colors shadow-lg">
              contact us
            </button>
          </div>

        </div>
      </section>

    </div>
  );
};

export default RCMServices;

